const TYPES = {
    GET_NEWS: 'GET_NEWS',
    GET_NEWS_COMPLETE: 'GET_NEWS_COMPLETE',
    GET_NEWS_FAILED: 'GET_NEWS_FAILED'
};

export default {
    TYPES,

    getNews: () => ({
        type: TYPES.GET_NEWS
    }),

    getNewsSuccess: news => ({
        type: TYPES.GET_NEWS_COMPLETE,
        payload: {news}
    }),

    getNewsFailed: error => ({
        type: TYPES.GET_NEWS_FAILED,
        payload: {error}
    })
};
